export class StatusConstant {
    statusSuccess = 200;
    statusInternalServerError = 500;
    statusNotFound = 404;
    statusCreated = 201;
    statusAccepted = 202;
    statusNonAuthoritativeInformation = 203;
    statusNoContent = 204;
    statusRequestTimeout = 408;
    statusNotImplemented = 501;
    statusBadGateway = 502;
    statusServiceUnavailable = 503;
    statusGatewayTimeout = 504;
    statusHTTPVersionNotSupported = 505;
}

export class TouchType {
    Main=1;
    Item=2;
}

export class TouchesTypeId {
    Folder=1;
    Form=2;
}
